<template>
    <div>
        <div class="content-caption dashed">
            <span>审核信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">审核：</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="auditState">
                        <el-radio label="1">通过</el-radio>
                        <el-radio label="-1">不通过</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>机构信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">入职机构：</label>
                </div>
                <div class="form-value">
                    <span>{{staffEnrollForm.staffComName}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>其他信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">员工编号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input v-model="staffEnrollForm.staffNo"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="">初始密码：</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input type="text" v-model="staffEnrollForm.password"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="">审核备注：</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input type="textarea" v-model="staffEnrollForm.auditDesc"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    export default {
        name: 'swb-staff-enroll-from-audit',
        desc: '入职人员审核',
        props: ["row"],
        data: function () {
            return {
                staffEnrollForm: {},
                auditState: "1"
            }
        },
        created: function () {
            let staffEnrollForm = {};
            staffEnrollForm.staffComId = this.row.staffComId;
            staffEnrollForm.staffComName = this.row.staffComName;
            staffEnrollForm.staffNo = this.row.staffNo || null;
            this.staffEnrollForm = staffEnrollForm;
        },
        methods: {
            getDlgResult(){
                let result = {};
                let self = this;
                let staffEnrollForm = self.staffEnrollForm;
                staffEnrollForm.auditState = self.auditState;
                result.type = 'info';
                result.data = staffEnrollForm;
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/staffBiz/StaffEnrollFromAudit.vue